<template>
  <div class="homePageHotWrap">
    <div class="homePage_hot">
      <!-- <div class="commonBg"></div> -->
      <div class="homePage_hot_toptitle">
        <div class="homePage_hot_toptitlebox">
          <span class="back" @click="back"></span>
          <span
            class="close"
            v-show="
              this.$store.state.system == 'android' &&
              applets != 'xcx' &&
              !$store.state.isXcx &&
              this.$store.state.isInGame
            "
            @click="closeCommunity"
          ></span>
        </div>
        <div class="homePage_hot_title">
          <h2>{{ topic.subjectName }}</h2>
          <p>
            <span>阅读：{{ topic.topicViewNum }}</span>
            <em>|</em>
            <span>讨论：{{ topic.topicCommentNum }}</span>
          </p>
        </div>
      </div>
      <div class="uploadPage_toptitle" v-show="slide">
        <div class="messageTop">
          <div class="messageTop_back" @click="back"></div>
          <div class="messageTop_con">{{ topic.subjectName }}</div>
        </div>
      </div>
      <span
        class="quickRelease"
        @click="quickRelease"
        v-show="canUse != 2"
      ></span>
      <van-pull-refresh
        v-model="isLoading"
        success-text="刷新成功"
        @refresh="onRefresh"
        v-swipeup="(e) => vueTouch('上滑', e)"
      >
        <!-- 筛选条件 -->
        <div class="conditions clear">
          <p>筛选条件</p>
          <div class="conditons_right" @click="show = true">{{ sortName }}</div>
          <van-action-sheet
            v-model="show"
            :actions="actions"
            cancel-text="取消"
            close-on-click-action
            @cancel="onCancel"
            @select="onSelect($event)"
          />
        </div>
        <!-- 已發布帖子 -->
        <van-list
          v-model="listInit.loading"
          :finished="listInit.finished"
          finished-text="没有更多了"
          @load="onLoad"
          offset="300"
        >
          <card
            v-for="item in topicsList"
            :key="item.id"
            :cardData="item"
            :subjectId="Number(topic.id)"
          ></card>
        </van-list>
      </van-pull-refresh>
    </div>
    <sideRight v-if="$padFalg != 'other'"></sideRight>
  </div>
</template>
<script>
import get from '@/api/get';
import getDateDiff from '@/assets/js/time';
import getTime from '@/utils/time';
import card from '../../../card';
import * as _code from '@/utils/code';
import arrNewSet from '@/utils/arrNewSet';
import { Toast } from 'vant';
import { mapState } from 'vuex';
import sideRight from '@/components/sideRight';
export default {
  name: 'hot',
  components: { card, sideRight },
  data() {
    return {
      applets: window.user.weixcode ? 'xcx' : '',
      newpage: false,
      slide: false, //控制上滑是顶部样式
      show: false,
      actions: [
        { name: '最新回复', id: 0 },
        { name: '最新發布', id: 4 },
        { name: '热门', id: 2 }
      ],
      topic: {},
      topicsList: [],
      sortType: 0,
      sortName: '最新回复',
      isLoading: false,
      pageNo: 1,
      listInit: {
        loading: false,
        finished: false
      },
      canUse: ''
    };
  },
  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.topic = this.$route.query;
    // this.init();
    let _this = this;
    window.onscroll = function () {
      _this.slide =
        (document.documentElement.scrollTop || document.body.scrollTop) > 145;
    };
    if (document.getElementsByTagName('html')[0].style.fontSize == '70px') {
      $('.quickRelease').hide();
    }
  },
  computed: {
    ...mapState({
      token: 'token'
    })
  },
  watch: {
    token(ne, ol) {
      // this.init();
    },
    $route(to, from) {
      //当参数改变时就会触发比方法，以此达到数据属性
      if (this.$route.name == 'subjectPage') {
        this.pageNo = 1;
        this.newpage = true;
        this.topic = this.$route.query;
        this.init();
      }
    }
  },
  // activated() {
  //   this.topic = this.$route.query;
  //   console.log(2);
  //   console.log(this.topic);
  //   this.init();
  // },
  methods: {
    back() {
      this.$router.go(-1);
    },
    onCancel() {
      Toast('取消');
    },
    onSelect(item) {
      this.newpage = true;
      if (this.sortType != item.id) this.pageNo = 1;
      if (item.name == '最新回复')
        (this.sortType = 0), (this.sortName = item.name);
      if (item.name == '热门') (this.sortType = 2), (this.sortName = item.name);
      if (item.name == '最新發布')
        (this.sortType = 4), (this.sortName = item.name);
      this.pageNo = 1;
      this.init();
    },
    init(cb) {
      // 获取帖子列表
      let _this = this;
      let topicInfo = {
        queryType: 3,
        subjectId: Number(this.topic.id),
        subjectName: this.topic.subjectName,
        sortType: this.sortType,
        pageNo: this.pageNo,
        pageSize: 10
      };
      if (this.token) {
        get.getTopics(topicInfo).then((res) => {
          if (res.data.code == 0) {
            this.topic.topicCommentNum = res.data.data.topicCommentNum;
            this.topic.topicViewNum = res.data.data.topicViewNum;
            this.canUse = res.data.data.canUse;
            var _data = res.data.data.list;
            getTime(_data);
            if (this.newpage) {
              _this.topicsList = _data;
              this.newpage = false;
            } else {
              _this.topicsList = _this.topicsList.concat(_data);
            }
            _this.topicsList = arrNewSet(_this.topicsList);
            if (_data.length < 10) {
              _this.listInit.finished = true;
              _this.pageNo = _this.pageNo == 1 ? 1 : _this.pageNo--;
            } else {
              _this.pageNo++;
            }
            console.log(2, _this.listInit);
            cb && cb(_data);
            if (!this.topicsList.length) {
              Toast('暂无内容');
            }
          } else {
            // this.errorMessage(res.data);
          }
        });
      }
    },
    quickRelease() {
      if (this.$store.state.postingFlag) {
        this.$router.push({
          name: 'postPage',
          query: {
            subjectName: this.topic.subjectName,
            id: this.topic.id,
            subjectType: this.topic.subjectType
          }
        });
      } else {
        Toast('功能维护中，暂不支持发帖');
      }
    },
    //
    onLoad() {
      let _this = this;
      setTimeout(() => {
        _this.init(function (data) {
          // 加载状态结束
          _this.listInit.loading = false;
          // 数据全部加载完成
          if (data.length < 10) {
            _this.listInit.finished = true;
            _this.pageNo > 1 ? _this.pageNo-- : 1;
          }
        });
      }, 1000);
    },
    vueTouch(text, e) {
      let _this = this;
      _this.listInit.finished = false;
      _this.listInit.loading = true;
      setTimeout(() => {
        _this.init(function (data) {
          // 加载状态结束
          _this.listInit.loading = false;
          // 数据全部加载完成
          if (data.length < 10) {
            _this.listInit.finished = true;
            _this.pageNo > 1 ? _this.pageNo-- : 1;
          }
        });
      }, 1000);
    },
    // 下拉刷新
    onRefresh() {
      var _this = this;
      setTimeout(() => {
        _this.isLoading = false;
        _this.init();
        // Toast("刷新成功");
      }, 1000);
    },
    closeCommunity() {
      window.pd.onBBSClose();
    },
    //错误提示
    errorMessage(data) {
      let code = data.code;
      if (code != 2050) {
        let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        Toast(msg);
      }
    }
  }
};
</script>
<style scoped></style>